import {observable, action, makeObservable} from 'mobx';
import {AllowedFileExtensionsAiChatUploads, FileTypesToUploadAiStudio} from "../serverClientShared/sharedEnums";
import {AiRequester} from "../MobxStores/RequestApi/AiRequester"
import {modalStore, projectStore} from "../index";
import Utility, {UPLOAD_CHUNK_SIZE} from "../Utility";
import Utilty from "../Utility";
import {saveToHistory} from "../Components/Editor/Actions/AddNode/SaveToHistory";
import ParsingUtility from "../Utilities/FileParsingUtility/ParsingUtility";


export class AiStore {
    isInitiated = false;
    currentThreadIndex = 0;
    attachedFiles = []
    isChatOpen = false
    isTestChatOpen = false
    isSidebarOpen = false
    abortedFiles = new Set()
    position = {y: 0, x: 0}
    sendMessageToIframe = () => {
    };
    sendMessageToTestIframe = () => {
    };

    constructor(modalStore, projectStore, procedureStore, generalStore, editorStore) {
        makeObservable(this, {
            isInitiated: observable,
            currentThreadIndex: observable,
            sendMessageToIframe: observable,
            sendMessageToTestIframe: observable,
            isChatOpen: observable,
            isTestChatOpen: observable,
            isSidebarOpen: observable,
            position: observable,
            attachedFiles: observable,
            abortedFiles: observable,
            size: action,
            uploadFile: action,
            openOrCloseChat: action,
            sendInitialValues: action,
            sendContextToIframe: action,
            uploadFiles: action,
            moveChatPosition: action,
            compressFiles: action,
            openFilePreview: action,
            abortFileUpload: action,


        });
        this.modalStore = modalStore;
        this.procedureStore = procedureStore;
        this.projectStore = projectStore;
        this.generalStore = generalStore;
        this.editorStore = editorStore;

    }

    size = (originalSize) => {
        const isMobile = Utilty.isMobile()
        if (isMobile) {
            return '100%'
        } else {
            return originalSize
        }
    }
    uploadFile = async (file) => {
        if (!this.location) {
            this.modalStore.showErrorMessage("No location set for AI store");
            return;
        }
        try {
            const response = await AiRequester.uploadFile(this.location, file);
            this.Threads[this.currentThreadIndex].messages.push({
                role: 'user',
                content: response
            });
        } catch (error) {
            this.modalStore.showErrorMessage("Failed to upload file: " + error.message);
        }
    };

    openOrCloseChat = (isOpen) => {
        this.isChatOpen = isOpen
    };
    openThreadsSideBar = (isSidebarOpen) => {
        this.isSidebarOpen = isSidebarOpen
        if (isSidebarOpen) {
            this.moveChatPosition({dx: 0, dy: 0})
        }
    }
    resetChatPosition = () => {
        this.position = {x: 0, y: 0}
    }
    abortFileUpload = (fileName) => {
        if (!this.abortedFiles.has(fileName)) {
            this.abortedFiles.add(fileName);
        }
    }

    moveChatPosition({dx, dy}) {
        if (dx !== 0 || dy !== 0) {
            if (!this.isDragging) {
                this.isDragging = true;
                this.savedScrollY = window.pageYOffset;
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.top = `-${this.savedScrollY}px`;
                document.body.style.width = '100%';
            }
        }
        const containerWidth = (this.isSidebarOpen && this.isChatOpen)
            ? 758
            : this.isChatOpen
                ? 520
                : 120;

        const containerHeight = this.isChatOpen
            ? Math.min(window.innerHeight * 0.9, 738)
            : 92;

        const maxX = window.innerWidth - containerWidth;
        const maxY = window.innerHeight * 0.95 - containerHeight;
        const minX = 0;

        if (dx === 0 && dy === 0) {
            if (this.isDragging) {
                this.isDragging = false;
                this.restoreScrollAfterDelay();
            }
            const midX = window.innerWidth / 2;
            const midY = window.innerHeight / 2;

            const newX = this.position.x < midX ? minX : maxX;
            const newY = this.position.y < midY ? 0 : maxY;

            this.position = {x: newX, y: newY};
            return;
        }

        let newX = this.position.x - dx;
        let newY = this.position.y - dy;

        if (newX < minX) newX = minX;
        if (newX > maxX) newX = maxX;

        if (newY < 0) newY = 0;
        if (newY > maxY) newY = maxY;

        this.position = {x: newX, y: newY};
        if (this.scrollRestoreTimeout) {
            clearTimeout(this.scrollRestoreTimeout);
        }

        this.scrollRestoreTimeout = setTimeout(() => {
            if (this.isDragging) {
                this.isDragging = false;
                this.restoreScrollAfterDelay();
            }
        }, 200);
    }

    restoreScrollAfterDelay() {
        setTimeout(() => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';

            if (typeof this.savedScrollY === 'number') {
                window.scrollTo(0, this.savedScrollY);
            }

            this.savedScrollY = null;
        }, 200);
    }

    sendInitialValues = async (location, sendMessageToIframe, isTestMode, workspace) => {
        if (!location) {
            location = window.location.href
        }
        try {
            const {url, token, aiUrl, aiModels} = await AiRequester.getInitialValues(this.generalStore.workspace);
            await sendMessageToIframe({
                functionName: 'setInitValues',
                functionInput: JSON.stringify([token, workspace, url, aiUrl, aiModels, this.generalStore.domainSettings.MaxAiRequests,
                    this.generalStore.domainSettings.CurrentAiRequestsCount, this.generalStore.domainSettings.LastTimeAiRequestsMaxUpdated, this.generalStore.domainSettings.Theme, this.generalStore.domainSettings.IsHP, location, Utilty.isMobile(), isTestMode])
            });
        } catch (err) {
            if ((err.response && err.response.status === 533) || err.code === 'ERR_BAD_RESPONSE') {
                window.location.href = '/logout';
            } else{
                this.isTestChatOpen = false
                this.modalStore.showErrorMessage('Couldn’t start chat. Try again')
            }
        }
    }

    sendContextToIframe = (url) => {
        this.sendMessageToIframe({functionName: 'saveContext', functionInput: JSON.stringify([url])});
    }
    compressFiles = async (files, abortedFiles = new Set()) => {
        const filesAfterCompression = [];
        for (const file of files) {
            if (abortedFiles.has('ABORT ALL')) {
                return []
            }
            const fileAfterCompression = await Utility.shrinkFile(file);
            filesAfterCompression.push(fileAfterCompression)
        }
        return filesAfterCompression;
    }
    parseFiles = async (files, isFromLibrary) => {
        const parsingPromises = files.map(async (fileObject, i) => {
            const file = fileObject?.file ?? fileObject;
            const fileName = file.OriginalFileName ? file.OriginalFileName + '.' + file.FileExtension : file.name ?? file.FileName + '.' + file.FileExtension;
            try {
                const parsedFile = await ParsingUtility.parseFileByType(fileObject, isFromLibrary, false, this.abortedFiles);
                if (!parsedFile) {
                    throw new Error('failed parsing file');
                }
                this.sendAiProgressLoaderValue(file.name ?? fileName, 100);
                this.sendFilesMessages(parsedFile, fileName);
                return parsedFile;
            } catch (err) {
                this.modalStore.showErrorMessage("Failed to parse file: " + fileName);
                this.sendMessageToIframe({
                    functionName: 'cancelUploadingFile',
                    functionInput: JSON.stringify([file.name ?? fileName])
                });
                return false;
            }
        });
        const parsedFilesMessage = await Promise.all(parsingPromises);
        return parsedFilesMessage.filter(Boolean);
    }

    handleFilesUploadsFromIframe = async (files) => {
        try {
            this.generalStore.isProgressLoaderLinear = false
            files.forEach(file => {
                const fileName = file.name ?? file.FileName ?? file.OriginalFileName;
                if (fileName) {
                    this.abortedFiles.delete(fileName);
                }
            });
            const regexPatterns = Object.values(FileTypesToUploadAiStudio).map(
                (pattern) => new RegExp(pattern, 'i')
            );
            const filesToUpload = files
            const associatedFiles = await this.uploadFiles(filesToUpload, true);
            const filesToParse = files.map((file, i) => {
                    if (regexPatterns.some((regex) => regex.test(file.type) || regex.test(file.name))) {
                        return {...associatedFiles[i], name: file.name}
                    } else {
                        return {file: file, FileId: associatedFiles[i].FileId}
                    }
            });
            const parsedFilesMessage = await this.parseFiles(filesToParse, false);
            this.abortedFiles.clear()
            return parsedFilesMessage;
        } catch (e) {
            console.log(e)
            modalStore.showErrorMessage('Error Uploading Files');
        } finally {
            this.generalStore.progressLoaderValue = null;
            this.generalStore.progressIndex = 0
            this.generalStore.isProgressLoaderLinear = true
        }
    }
    uploadFiles = async (files, isSendProgressToChat) => {
        try {
            this.generalStore.isProgressLoaderLinear = false
            const filesAfterCompression = await this.compressFiles(files);
            const uploadedCounter = [0];
            const totalChunks = filesAfterCompression.reduce((accumulator, file) => Math.ceil(file.size / UPLOAD_CHUNK_SIZE) + accumulator, 0);
            this.isLoaderOpen = false;
            const promises = filesAfterCompression.map((file, i) => this.generalStore.uploadFile(file, totalChunks, uploadedCounter, projectStore.currentProject.ProjectIdentifier, 'root', null, null, i, true).then((result) => {
                if (isSendProgressToChat) {
                    this.sendAiProgressLoaderValue(file.name, 10);
                }
                return result;
            }));
            const associatedFiles = await Promise.all(promises);
            return associatedFiles;
        } catch (e) {
            modalStore.showErrorMessage(`${files.length > 1 ? 'Error Uploading Files' : `Error Uploading File: ${files[0].name}`}`);
        }
    };

    sendAiProgressLoaderValue = (name, value) => {
        this.sendMessageToIframe({
            functionName: 'updateAiProgressLoaderValue',
            functionInput: JSON.stringify([name, value])
        });
    };

    sendFilesMessages = (parsedFileMessage, fileName) => {
        this.sendMessageToIframe({
            functionName: 'addFilesMessagesFromWeb',
            functionInput: JSON.stringify([parsedFileMessage, fileName])
        });
    };

    openMediaModal = () => {
        this.modalStore.modalData = {
            ...this.modalStore.modalData,
            onMediaSelected: async (files) => {
                await this.handleFilesUploadFromMediaLibrary(files)
            },
            onlyImages: false
        };
        this.modalStore.isMediaLibraryModalOpen = true;
    }
    handleFilesUploadFromMediaLibrary = async (files) => {
        const allowedExtensionsSet = new Set(Object.values(AllowedFileExtensionsAiChatUploads));
        const filteredFiles = files.filter(file => {
                if (file.Size >= 512 * 1024 * 1024) {
                    return false
                } else if (!allowedExtensionsSet.has(file.FileExtension?.replace(/^\./, "").toLowerCase())) {
                    this.modalStore.showErrorMessage(`Unsupported file type.`)
                    return false
                }
                return true
            }
        );
        if (filteredFiles.length === 0) {
            this.modalStore.showErrorMessage('Unsupported file type.')
            return;
        }
        if (filteredFiles.length > 10) {
            this.modalStore.showErrorMessage("You can upload up to 10 files only per message.")
            return;
        }
        this.modalStore.isMediaLibraryModalOpen = false;
        this.sendMessageToIframe({
            functionName: 'uploadFilesFromMediaLibrary',
            functionInput: JSON.stringify([filteredFiles])
        })
        await this.parseFiles(filteredFiles, true);
        this.modalStore.modalData = {
            ...this.modalStore.modalData,
            onMediaSelected: null,
        }
    }

    showChangesInNodeEditor = async () => {
        saveToHistory()
        this.procedureStore.currentProcedure.ProcedureIdentifier = null
        this.editorStore.refreshTrigger = !this.editorStore.refreshTrigger;
        await setTimeout(() => {
            this.editorStore.autoArrangeTrigger++
        }, 2000)
    }

    showChangesInProcedureView = (procedure) => {
        this.procedureStore.updateProcedureInStores(procedure)
        this.procedureStore.getEditingVersions()
    }

    showChangesInProjectView = () => {
        const projectId = this.projectStore.currentProject?.ProjectIdentifier;
        if (!projectId) return;
        this.projectStore.setCurrentProjectDetails(projectId, true);
        this.projectStore.refreshCurrentFolderLevel();
    }

    showErrorMessage(message) {
        this.modalStore.showErrorMessage(message);
    }

    openFilePreview = (file) => {
        this.modalStore.modalData = {
            ...this.modalStore.modalData,
            file: file
        };
        this.modalStore.isFilePreviewModalOpen = true;
    }

    getProcedureBasic() {
        const {
            ProjectRef,
            ProcedureIdentifier,
            ProcedureName,
            AIInstructions,
            ProcedureDescription,
            ParentFolder,
            ThreeDModelsConnected,
            PreRequiredProcedures,
            LanguageVisibility,
            DefaultLanguage
        } = this.procedureStore.currentProcedure;
        const NestedNodes = []
        this.editorStore.nodes.forEach(node => {
            const nodeData = {...node.data.nodeData}
            delete nodeData._id
            delete nodeData.Style
            delete nodeData.InteractiveIOitems
            delete nodeData.HintsPopupIdentifiers
            delete nodeData.NodeMediaFiles
            delete nodeData.Connections
            const newConnectionsData = []
            nodeData.ConnectionsData.forEach(
                connection => {
                    const newConnection = {...connection}
                    delete newConnection._id
                    delete newConnection.ConnectionCoordinates
                    delete newConnection.finalTarget
                    delete newConnection.parentConnectionId
                    delete newConnection.connectionLines
                    delete newConnection.connectionPoints
                    delete newConnection.ConnectionsData
                    newConnectionsData.push(newConnection)
                }
            )
            nodeData.ConnectionsData = newConnectionsData
            NestedNodes.push(nodeData)
        })
        const relevantData = {
            ProjectRef,
            ProcedureIdentifier,
            ProcedureName,
            AIInstructions,
            ProcedureDescription,
            ParentFolder,
            NestedNodes,
            ThreeDModelsConnected,
            PreRequiredProcedures,
            LanguageVisibility,
            DefaultLanguage
        };
        return JSON.stringify(relevantData);
    }
}